import { MS_PER_DAY } from '@/utils/dateRange'

/**
 * The durations this codebase sets explicitly. Success toasts are absent
 * deliberately: they use zag's own per-type default of 2000ms, and that shorter
 * life is load-bearing rather than incidental.
 *
 * KBE-771 tried passing `standard` to `createToaster` as a group-wide default so
 * the many direct `toaster.create` callers would be covered too. Success toasts
 * then lived 5000ms, seven of them stacked over the right half of the digraph
 * canvas, and `layout.spec.ts`'s "Variables should be connected as path graph"
 * failed every run — the toast stack covered the drag's source and target nodes,
 * so no edge could be drawn. Lengthening a toast is not a safe default: toasts
 * are `bottom-end`, which is inside the canvas and inside the pointer path.
 *
 * zag's other per-type defaults are 5000ms for info and error and Infinity for
 * loading, so an unspecified duration already matches `standard` everywhere
 * except success.
 */
export const TOAST_DURATIONS = {
  standard: 5000,

  // Chakra v3's toaster has no persistent option, so a day stands in for
  // "stays until the researcher dismisses it".
  error: MS_PER_DAY,
} as const
